import { useFlag, useFlagsStatus } from '@unleash/proxy-client-vue';
import { computed, Ref } from 'vue';

/**
 * useKillSwitchFlag has special functionality as compared to `useFlag` so that it
 * returns `true` if Unleash is not available in the environment. This check prevents
 * a system failure in Unleash from taking down major parts of our application.
 */
export const useKillSwitchFlag = (featureFlagName: string): Ref<boolean> => {
  const flagsStatus = useFlagsStatus();

  const unleashFlagsAreInitialized = computed(
    () => flagsStatus.flagsReady?.value ?? false,
  );

  const isFeatureFlagEnabled = useFlag(featureFlagName);

  return computed(() => {
    if (!unleashFlagsAreInitialized.value) {
      return true;
    }

    return isFeatureFlagEnabled.value;
  });
};
